import React from 'react';

import cn from 'classnames';
import { MdPrint } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import { Button } from '@modules/shared';

import styles from './PrintBlueCardButton.less';

type Props = {
  disabled?: boolean;
  onClick: () => void;
  loading?: boolean;
  isPrimary?: boolean;
  className?: string;
};

const PrintBlueCardButton: React.FC<Props> = ({
  disabled = false,
  onClick,
  loading,
  isPrimary,
  className,
}) => (
  <Button
    className={cn(className, styles.button)}
    loading={loading}
    fitText
    disabled={disabled}
    onClick={onClick}
    shape="round"
    size="large"
    type={isPrimary ? 'primary' : 'default'}
  >
    {loading ? <></> : <MdPrint />}
    <FormattedMessage id="youthProfile.AdvRequirementsPage.PrintBlueCardButton.content" />
  </Button>
);

export default PrintBlueCardButton;
